export const IndoGreenAssetData = [
    {
      id: 1,
      question: "The products available under the scheme are",
      answer: [
        { item: "Solar lighting systems (solar panel, inverter, batteries etc.)" },
        { item: "Solar water system (domestic and commercial use)" },
        { item: "Gas stoves" },
        { item: "Solar geysers, etc." },
      ],
      description: "The scheme is available to both individuals and businesses.",
    },
    {
      id: 2,
      question: "Requirements",
      answer: [
        { item: "Payslip (For individuals)" },
        { item: "Quotation from our authorized list of suppliers" },
        { item: "Fill in the application form" },
      ],
      description: "",
    },
    {
      id: 3,
      question: "List of Suppliers Under Indo Green Asset Finance Scheme",
      answer: [
        { item: "Vew Investments" },
        { item: "Saro Agro Industries Limited" },
        { item: "Davis and Shirtliff" },
        { item: "Newtech Business Systems Limited" },
        { item: "Next Solutions Zambia Limited" },
        { item: "Pafriw Hardware" },
        { item: "World of Solar" },
        { item: "Radian Stores" },
        { item: "Home Power Investments" },
      ],
      description: "",
    },
];
